import { AtDateInputProps } from "./at-date-input.types";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { GlobalDatePickerStyles } from "../../../theme/global-styles";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import dayjs, { Dayjs } from "dayjs";

export const AtDateInput = ({
  label,
  required,
  onChange,
  disabled,
  error,
  value,
  helpText,
  format = "DD/MM/YYYY",
  placeholder,
}: AtDateInputProps) => {
  const handleChange = (newValue: Dayjs | null) => {
    // Handle null or invalid dates
    if (!newValue || !newValue.isValid()) {
      onChange?.(null);
      return;
    }

    const dateValue = newValue.toDate();

    // Double-check that the Date object is valid
    if (isNaN(dateValue.getTime())) {
      onChange?.(null);
      return;
    }

    onChange?.(dateValue);
  };

  const dayjsValue = (() => {
    if (!value) return null;
    const dayjsDate = dayjs(value);
    return dayjsDate.isValid() ? dayjsDate : null;
  })();

  // Create a custom theme to override the primary color
  const customTheme = createTheme({
    palette: {
      primary: {
        main: "#833177", // Using the actual hex color from --color-primary-500
      },
    },
  });

  return (
    <>
      <GlobalDatePickerStyles />
      <ThemeProvider theme={customTheme}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label={label}
            value={dayjsValue}
            onChange={handleChange}
            disabled={disabled}
            slotProps={{
              textField: {
                required,
                error,
                helperText: helpText,
                size: "small",
                variant: "outlined",
                fullWidth: true,
                placeholder: placeholder,
              },
            }}
            format={format}
          />
        </LocalizationProvider>
      </ThemeProvider>
    </>
  );
};
